"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _round2 = _interopRequireDefault(require("lodash/round"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Displays the rounded number value
 *
 * Settings:
 *  - prefix: string to be placed before the value
 *  - suffix: string to be placed after the value
 *  - decimalRound: how many decimal points to round the value
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var noValue = false;
    if ((0, _isNil2["default"])(value)) {
      noValue = true;
    }

    // setting.style should only be used in extreme circumstances
    // we should not get in the habit of putting styles in appdefs

    var roundedValue = 0;
    if (!noValue) {
      roundedValue = settings.decimalRound ? (0, _round2["default"])(value, settings.decimalRound) : (0, _round2["default"])(value);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      style: !(0, _isNil2["default"])(settings.style) ? settings.style : {},
      className: !(0, _isNil2["default"])(settings.style) ? '' : _style["default"].container
    }, !noValue ? /*#__PURE__*/_react["default"].createElement("div", null, "".concat(settings.prefix).concat(roundedValue).concat(settings.suffix)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center"
    }));
  };
};